"use client";
import { toast } from "react-toastify";
import { handleTRPCError } from "@/utils/errorHandling";
import { api } from "@/utils/api";
import { Button } from "@/components/ui/button"
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog"

import { Label } from "@/components/ui/label"
import { Loader2, AlertTriangle } from "lucide-react";
import { Input } from "./ui/input";
import { useState } from "react";


export const RawMessageDialog = ({ device_cuid, customer_cuid, disabled }: { device_cuid: string, customer_cuid: string, disabled: boolean }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const utils = api.useUtils();
    const { mutate, isPending } = api.command.send.useMutation({
        onError: async (error) => {
            handleTRPCError(error, "Failed to send message to the device");
            await utils.device.getErrors.invalidate({ device_cuid, customer_cuid });
        },
        onSuccess: async () => {
            toast.success("Message sent successfully");
            setOpen(false);
            await utils.device.getSMBResponses.invalidate({ device_cuid, customer_cuid });
        },
    });
    const handleClick = () => mutate({ device_cuid, customer_cuid, command: message });

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button disabled={disabled} size="sm">
                    <AlertTriangle className="mr-2 h-4 w-4" />
                    <span>
                        Raw Client Message
                    </span>
                </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Send Raw Client Message</DialogTitle>
                </DialogHeader>
                <div className="mb-6">
                    <div className="mb-6">
                        <p className="my-3 text-sm">This sends a raw message to the DSM client without any input validation. Please, use with caution.</p>
                        <Label htmlFor="name">
                            Message
                        </Label>
                        <Input id="message" className="my-1" placeholder="Message" value={message} onChange={(e) => setMessage(e.target.value)} />
                    </div>
                </div>
                <DialogFooter className="grid grid-cols-4">
                    <div></div>
                    <div></div>
                    <DialogClose asChild>
                        <Button variant="outline">
                            Cancel
                        </Button>
                    </DialogClose>
                    <Button onClick={handleClick} disabled={disabled || isPending}>
                        {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                        <span>
                            Send
                        </span>
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
